export default __webpack_public_path__ + "static/media/icon_answer_incomplete_circle.e6736d6d.svg";